<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />
    

    <div v-if="!modoEdicaoItem" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdplano) }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmplano" maxlength="100" v-uppercase />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <EquipamentoGrupoSelect v-model:idSelecionado="objEdicao.idequipamentogrupo" />
            </div>
            
            <div class="form-item">
                <EquipamentoFrame :initId="objEdicao.idequipamento" v-model:idSelecionado="objEdicao.idequipamento"/>
            </div>  
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Informações</label>
                <textarea v-model="objEdicao.obs" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
        </div>


        <div class="row-end">
            <button class="btn-confirm" @click="salvarDados">Salvar</button>
            <button class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>


    <div v-if="modoEdicaoItem">
        <div class="form-edit-page row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Plano</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(planoSelecionado.cdplano) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Nome/Descrição</label>
                <div class="field-label">{{ planoSelecionado.nmplano }}</div>
            </div>
            
            <div class="form-item-char40">
                <label class="label-caption">Grupo/Equipamentos</label>
                <div class="field-label">{{ planoSelecionado.nmgrupo }}{{ planoSelecionado.nmequipamento }}</div>
            </div>
        </div>

        
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <ManutServicoFrame :refreshKey="servicoFrameRefresh" v-model:objSelecionado="servicoSelecionado" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Detalhamento</label>
                    <input type="text" v-model="edDetalhamento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Intervalo KM</label>
                    <input type="text" class="input-right" v-model="edIntervalo_km" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Intervalo Horas</label>
                    <input type="text" class="input-right" v-model="edIntervalo_horas" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Intervalo Dias</label>
                    <input type="text" class="input-right" v-model="edIntervalo_dias" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Intervalo Meses</label>
                    <input type="text" class="input-right" v-model="edIntervalo_meses" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Antecedência KM</label>
                    <input type="text" class="input-right" v-model="edAntecedencia_km" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Antecedência Horas</label>
                    <input type="text" class="input-right" v-model="edAntecedencia_horas" v-number maxlength="11" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Antecedência Dias</label>
                    <input type="text" class="input-right" v-model="edAntecedencia_dias" v-number maxlength="11" />
                </div>
            </div>


            <div class="row-end row-space">
                <label for="ckAtivoItem">Ativo</label>
                <input id="ckAtivoItem" type="checkbox" class="input-checkbox" v-model="ckAtivoItem" />
            </div>

            
            <div class="row-end">
                <button class="btn-confirm" @click="salvarDadosItem">Salvar Ítem</button>
                <button @click="cancelForm">Encerrar</button>
            </div>
        </div>
    </div>


    <div v-if="lsDados.length>0">
        <div class="table-wrapper"><table>
            <thead><tr>
                <th>Serviço</th>
                <th>Int KM</th>
                <th>Int Horas</th>
                <th>Int Dias</th>
                <th>Int Meses</th>
                <th>Ant KM</th>
                <th>Ant Horas</th>
                <th>Ant Dias</th>
                <th>Situação</th>
            </tr></thead>

            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarItem(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
            >
                <td>{{ obj.nmservico }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.intervalo_km) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.intervalo_horas) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.intervalo_dias) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.intervalo_meses) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.antecedencia_km) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.antecedencia_horas) }}</td>
                <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.antecedencia_dias) }}</td>
                <td class="col-width-char10 center">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>
    </div>
</template>
  
<script setup>
import { onMounted, reactive, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarManutPlano } from '@/models/ManutPlano';
import { criarManutPlanoItem } from '@/models/ManutPlanoItem';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ManutServicoFrame from '@/components/frames/ManutServicoFrame.vue';

const emit = defineEmits(['close', 'salvo'])
const props = defineProps({idEdicao: {type: Number, default: 0}})

const ckAtivo = ref(false);
const objEdicao = criarManutPlano();
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicaoItem = ref(false);
const msgAlerta = ref(false);

const planoSelecionado = reactive({});      // MELHOR "reactive" POR QUESTÕES DE CODIFICAÇÃO SEM NECESSIDADE DE USAR ".value"


const servicoSelecionado = ref({});         // NECESSÁRIO "ref" DEVIDO COMPATIBILIDADE COM COMPONENTE "FRAME"
const ckAtivoItem = ref(true);
const edIntervalo_km = ref(null);
const edIntervalo_horas = ref(null);
const edIntervalo_dias = ref(null);
const edIntervalo_meses = ref(null);
const edAntecedencia_km = ref(null);
const edAntecedencia_horas = ref(null);
const edAntecedencia_dias = ref(null);
const edDetalhamento = ref(null);
const idItemEdicao = ref(null);
const servicoFrameRefresh = ref(0);


function cancelForm() {emit('close');}


async function editarItem(obj){
    if (!modoEdicaoItem.value) return;
    edIntervalo_km.value = Funcoes.formatInteger(obj.intervalo_km);
    edIntervalo_horas.value = Funcoes.formatInteger(obj.intervalo_horas);
    edIntervalo_dias.value = Funcoes.formatInteger(obj.intervalo_dias);
    edIntervalo_meses.value = Funcoes.formatInteger(obj.intervalo_meses);
    edAntecedencia_km.value = Funcoes.formatInteger(obj.antecedencia_km);
    edAntecedencia_horas.value = Funcoes.formatInteger(obj.antecedencia_horas);
    edAntecedencia_dias.value = Funcoes.formatInteger(obj.antecedencia_dias);
    edDetalhamento.value = obj.detalhamento;
    ckAtivoItem.value = obj.ativo === 'S';
    idItemEdicao.value = obj.id;
    servicoFrameRefresh.value = obj.cdservico; // AQUI TROCA APENAS NA PRIMEIRA VEZ!!!!
}


async function lerDados() {
    try{
        isLoading.value = true;
        if (props.idEdicao > 0) {
            const req = await Api.getCadastroById('manut_plano', props.idEdicao);
            Object.assign(objEdicao, req[0]);
            await lerItens();
        }else{
            objEdicao.idmunicipio   = globalStore.idmunicipio;
        }
        objEdicao.idlogin           = globalStore.idlogin;
        objEdicao.idusuario         = globalStore.idusuario;
        ckAtivo.value               = objEdicao.ativo === 'S';
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    }finally{isLoading.value = false;}
}


async function lerItens(){
    try{
        msgAlerta.value = null;
        const req = await Api.genericPost('/listas/manut_plano_item', {
            idmunicipio: globalStore.idmunicipio, 
            intparam1: (planoSelecionado.id) ? planoSelecionado.id : props.idEdicao });
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}



function limparCamposItem(){
    idItemEdicao.value=null;
    servicoFrameRefresh.value=null;
}

async function salvarDados() {
    try {
        msgAlerta.value = validarDados();
        if (msgAlerta.value) return;
        isLoading.value     = true;
        objEdicao.ativo     = ckAtivo.value ? 'S' : 'N';
        const response      = await Api.genericPut('/cad/manut_plano', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            
            // SETAR EDIÇÃO DOS SERVIÇOS VINCULADOS AO PLANO
            const plano = await Api.genericPost('/listas/manut_plano', {idmunicipio: globalStore.idmunicipio, id: response.id});
            if (plano.length>0){
                Object.assign(planoSelecionado, plano[0]);
                modoEdicaoItem.value=true;
            }
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value = false;}
}


async function salvarDadosItem() {
    try {
        msgAlerta.value = validarDadosItem();
        if (msgAlerta.value) return;
        
        // CRIAR UM PLANOITEM "LIMPO" E ATRIBUIR OS EDITS
        const planoItem = criarManutPlanoItem();
        planoItem.id = idItemEdicao.value ?? 0;
        planoItem.idplano = planoSelecionado.id ?? 0;           // <- ajuste: de onde vem o plano atual
        planoItem.idservico = servicoSelecionado.value.id;
        planoItem.intervalo_km = Funcoes.integerFromString(edIntervalo_km.value);
        planoItem.intervalo_horas = Funcoes.integerFromString(edIntervalo_horas.value);
        planoItem.intervalo_dias = Funcoes.integerFromString(edIntervalo_dias.value);
        planoItem.intervalo_meses = Funcoes.integerFromString(edIntervalo_meses.value);

        planoItem.antecedencia_km = Funcoes.integerFromString(edAntecedencia_km.value);
        planoItem.antecedencia_horas = Funcoes.integerFromString(edAntecedencia_horas.value);
        planoItem.antecedencia_dias = Funcoes.integerFromString(edAntecedencia_dias.value);

        planoItem.detalhamento = (edDetalhamento.value ?? '').toString().trim()
        planoItem.ativo = ckAtivoItem.value ? 'S' : 'N';
        planoItem.idlogin = globalStore?.idlogin ?? 0;

        await Api.genericPut('/cad/manut_plano_item', planoItem);
        limparCamposItem();
        await lerDados();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value = false;}
}


function validarDados(){
    let r = Validar.texto(objEdicao.nmplano, "Informe nome ou descrição");
    if (!r.ok) return r.msg;
    if ((!objEdicao.idequipamentogrupo) && (!objEdicao.idequipamento)) return 'Informe o Grupo ou Equipamento';
    if ((objEdicao.idequipamentogrupo) && (objEdicao.idequipamento)) return 'Escolha apenas uma opção entre Grupo ou Equipamento';
    return null;
}


function validarDadosItem(){
    let r = Validar.id(servicoSelecionado.value, "Informe o tipo de serviço");
    if (!r.ok) return r.msg;
    if ((!edIntervalo_dias.value)&&(!edIntervalo_horas.value)&&(!edIntervalo_km.value)&&(!edIntervalo_meses.value)){
        return 'Necessário informar algum valor de intervalo';
    }
    return null;
}


onMounted(lerDados)
</script>